import { queryOptions } from '@tanstack/react-query';

import { $api } from '../../../shared/api';
import { routes } from '../../../shared/api/routes';
import { TaskBoardViewState, TaskBoardViewStatePatch } from '../model/types/viewState';

interface ViewStateResponse {
    status: 'success';
    data: TaskBoardViewState;
}

const normalizeViewState = (state: ViewStateResponse['data']): TaskBoardViewState => ({
    ...state,
    filters: { ...state.filters, search: '' },
});

export const taskViewStateKeys = {
    all: ['taskViewState'] as const,
    detail: (url: string) => [...taskViewStateKeys.all, url] as const,
};

export const taskViewStateApi = {
    queryOptions: () => {
        const url = routes.getTaskBoardViewState();
        return queryOptions({
            queryKey: taskViewStateKeys.detail(url),
            queryFn: async ({ signal }) => {
                const response = await $api.get<ViewStateResponse>(url, { signal });
                return normalizeViewState(response.data.data);
            },
            staleTime: Infinity,
            gcTime: 0,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        });
    },
    update: async (patch: TaskBoardViewStatePatch) => {
        const response = await $api.patch<ViewStateResponse>(
            routes.updateTaskBoardViewState(),
            patch
        );
        return normalizeViewState(response.data.data);
    },
};
